<template>
    <chats-get
        :page="page"
        :include="[
            'messages(paginate:1,1)',
            'landlords(paginate:1,5)',
            'tenants(paginate:1,5)'
        ]"
        v-slot="{
            data: chats,
            meta,
            error,
            is_loading,
            has_loaded,
            get
        }"
    >
        <div v-if="!has_loaded || error">
            <base-loading
                :error="error"
                :retry="get"
                class="py-6"
            />

            <error-modal
                v-if="error"
                :error="error"
            />
        </div>

        <div v-else>
            <base-hint
                v-if="$gate.role('landlord')"
                name="landlords-chats-index"
            >
                <template slot="heading">
                    Instant messaging
                </template>

                <p class="mb-3">
                    Talk to tenants and listing applicants through our messaging service.
                </p>

                <p>
                    Conversations are logged for future reference, and you can avoid sharing your contact
                    details until absolutely necessary.
                </p>
            </base-hint>

            <base-hint
                v-else-if="$gate.role('tenant')"
                name="tenants-chats-index"
            >
                <template slot="heading">
                    Instant messaging
                </template>

                <p class="mb-3">
                    Talk to your landlord through our messaging service.
                </p>

                <p>
                    Conversations are logged for future reference, and you can avoid sharing your contact
                    details until absolutely necessary.
                </p>
            </base-hint>

            <div class="mb-6 bg-white rounded shadow">
                <header class="flex items-center px-4 border-b h-18 sm:px-6">
                    <div class="flex-grow">
                        <h1 class="text-lg font-normal">Messages</h1>
                    </div>
                </header>

                <template v-if="meta.count > 0">
                    <chats-list :chats="chats">
                        <truncate-hack
                            slot="primary"
                            slot-scope="{ chat }"
                        >
                            <with-variables
                                v-slot="{
                                    personas,
                                    total
                                }"
                                :variables="{
                                    personas: _.filter([...chat.landlords.data, ...chat.tenants.data], persona => !isMe(persona)),
                                    total: chat.landlords.meta.total + chat.tenants.meta.total - 1,
                                }"
                            >
                                {{ personas | comma-delimited({
                                    callback: persona => {
                                        return persona.name
                                    },
                                    total
                                }) }}
                            </with-variables>
                        </truncate-hack>
                        <truncate-hack
                            slot="secondary"
                            slot-scope="{ chat }"
                        >
                            <with-variables
                                v-slot="{ message }"
                                :variables="{
                                    message: _.get(chat, 'messages.data.0')
                                }"
                            >
                                <template v-if="message">
                                    <template v-if="message.text">
                                        {{ message.text }}
                                    </template>
                                    <template v-else>
                                        {{ message.persona.first_name }} sent {{ message.files_count }} {{ message.files_count > 1 ? 'files' : 'file' }}
                                    </template>
                                </template>

                                <base-na v-else />
                            </with-variables>
                        </truncate-hack>
                    </chats-list>

                    <footer class="px-4 text-sm font-semibold rounded-b bg-grey-bg sm:px-6 text-grey-darker">
                        <base-pagination
                            v-model="page"
                            :per-page="meta.per_page"
                            :from="meta.from"
                            :to="meta.to"
                            :last-page="meta.last_page"
                            :count="meta.count"
                            :total="meta.total"
                            :is-disabled="is_loading"
                        />
                    </footer>
                </template>

                <div
                    v-else
                    class="py-16"
                >
                    <div class="max-w-sm px-6 mx-auto text-center">
                        <h2 class="mb-2 text-xl font-semibold">
                            No messages
                        </h2>

                        <div class="text-base text-grey-darker">
                            <p>You haven't exchanged any messages yet.</p>

                            <p>Messages are started from tenancies or listing applications.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </chats-get>
</template>

<script>
    import _ from 'lodash'
    import PaginationMixin from '../../../../mixins/pagination'
    import ChatsGet from '../../../../components/chats-get'
    import ChatsList from '../../../../components/chats-list'

    export default {
        mixins: [
            PaginationMixin
        ],
        components: {
            ChatsGet,
            ChatsList
        },
        computed: {
            me () {
                return _.get(_.preload('tenant') || _.preload('landlord'), 'data')
            }
        },
        methods: {
            isMe (persona) {
                return this.me && this.me.object === persona.object && this.me.uuid === persona.uuid
            }
        }
    }
</script>
